<template>
  <module-configuration :data="config" :errors="errors" :useAuthentication="false">
    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>

        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel title="Pedidos">
      <div class="l-row">
        <div class="l-col">
          <div class="alert alert-info" role="alert">
            <h5 class="alert-heading">Atenção*</h5>
            Caso ocorram problemas de envio de NF-e emitidas via ERP\Painel, entre no <a href="https://seller.shopee.com.br/" target="_blank">Painel do Seller</a>,
            em <strong>Loja > Perfil da Loja > Configurações de NF-e</strong>, e marque em "Emissor de NF-e padrão" a opção <strong>"Outro"</strong>
          </div>
        </div>
      </div>
      <div class="l-row">
        <form-group label="Emissor de NF-e Shopee">
          <select class="form-select" v-model="config.taxInfo.useShopeeInvoice">
            <option v-for="option in taxInfoOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se será necessário o envio de dados fiscais do produto para a Shopee, caso a nota seja emitida pelo mesmo.</small>
        </form-group>

        <form-group label="Tipo de Arquivo NF-e" v-if="config.taxInfo.useShopeeInvoice">
          <select class="form-select" v-model="config.taxInfo.typeFileNFe">
            <option :value="null" selected>Selecione</option>
            <option v-for="option in taxTypeFileOptions" :key="option" :value="option">{{$t(`shopee.module.config.typeFileNFe.${option}.label`) }}</option>
          </select>
          <small class="form-help">Define o tipo de arquivo da NF-e que será enviada para a Shopee: [1: pdf], [2: jpeg], [3: png], <strong>[4: xml (Padrão)]</strong></small>
        </form-group>

        <order-retrieve-date-configuration :orderConfigs="config.order" :columns="6"/>
      </div>
      <div class="l-row">
        <form-group label="Link padrão da NFe (Opcional)">
          <input class="form-input" v-model="config.taxInfo.linkNFe">
          <small class="form-help">Usado para preencher o campo link no ecommerce quando a origem da NFe vier do marketplace.</br>Padrão: http://www.nfe.fazenda.gov.br/portal/principal.aspx</small>
        </form-group>
      </div>
    </panel>

    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados no Shopee.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados no Shopee.</small>
        </form-group>

      </div>
    </panel>
  </module-configuration>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'shopee'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'shopee',
      synchronizeOptions: [
        true,
        false
      ],
      taxInfoOptions: [
        false,
        true
      ],
      taxTypeFileOptions: [
        '4'
      ],
      config: {
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null
        },
        synchronize: {
          stock: true,
          price: true
        },
        taxInfo: {
          useShopeeInvoice: false,
          typeFileNFe: null,
          linkNFe: null
        }
      }
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled'
      ])
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration
    }
  }
</script>
<style>
  .alert {
    position: relative;
    padding: 1rem 1rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
  }

  .alert-primary {
    color: #084298;
    background-color: #cfe2ff;
    border-color: #b6d4fe;
  }

  .alert-info {
    color: #055160;
    background-color: #cff4fc;
    border-color: #b6effb;
  }

  .alert-light {
    color: #636464;
    background-color: #fefefe;
    border-color: #fdfdfe;
  }

  .alert-heading {
    font-size: 1.2rem;
    font-weight: bold;
    color: #033842;
  }
</style>



// WEBPACK FOOTER //
// Shopee.vue?2fe788fe